module.exports = __webpack_public_path__ + "img/brand-adversal.b13d848e.svg";